export var FormTypes;
(function (FormTypes) {
    FormTypes["CONTACT_FORM"] = "contactForm";
})(FormTypes || (FormTypes = {}));
